<template>
  <div>
    <!-- <el-table :data="appList" :span-method="objectSpanMethod" border> -->
    <el-table :data="appList" border height="calc(100vh - 360px)">
      <el-table-column label="platform">
        <template slot-scope="scope">
          <span>{{ scope.row.platform }} </span>
        </template>
      </el-table-column>
      <el-table-column label="id">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column label="租户名字">
        <template slot-scope="scope">
          <span>{{ scope.row.tenantName }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="content" label="content"> </el-table-column>
      <el-table-column label="版本">
        <template slot-scope="scope">
          <span>{{ scope.row.version }} </span>
        </template>
      </el-table-column>

      <el-table-column prop="uploadUrl" label="uploadUrl" min-width="140">
      </el-table-column>
      <el-table-column prop="status" label="状态">
        <template slot-scope="scope">
          <el-switch
            active-color="#13ce66"
            :value="infoStatus(scope.row.status)"
            @change="changeStatus(scope.row)"
          ></el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="isForce" label="isForce">
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.isForce">是</el-tag>
          <el-tag v-else>否</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="下载地址">
        <template slot-scope="scope">
          <!-- <div class="url-con" v-for="item in scope.row.url">
            
          <span class="url-name"> {{ item.name }}</span> <el-input v-model="item.url"></el-input>
          <el-button size="small" @click="updateOne(scope.row)">修改</el-button>
        </div> -->
          {{ scope.row.lineUrl }}
        </template>
      </el-table-column>
      <!-- <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand">
            <el-form-item>{{ props.row}}</el-form-item>
            <div class="url-con" v-for="item in props.row.url">
              
              <el-form-item label="name">
                <el-input v-model="item.name"></el-input>
              </el-form-item>
              <el-form-item label="url">
                <el-input v-model="item.url"></el-input>
                
              </el-form-item>
              
            </div>
            <el-form-item>
                <el-button size="small" @click="updateOne(props.row)">修改</el-button>
              </el-form-item>
          </el-form>
        </template>
      </el-table-column> -->
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button @click="updateInfo(scope.row)">修改</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :page="pagination.page"
      :total="totalCount"
      @pageChanged="handleCurrentChange"
    >
    </pagination>
    <!-- <el-dialog
      :visible="!!editingPlatform"
      title="发布版本更新"
      width="1000px"
      @close="closeDialog"
    >
      <el-form :model="detail" ref="form" :rules="rules" label-width="100px">

        <el-form-item label="版本：" prop="coinType">
          <el-input v-model="detail.version"></el-input>
        </el-form-item>
        <el-form-item
          :label="detail.platform == 'apple' ? '跳转地址' : '下载地址'"
          prop="uploadUrl"
        >
          <el-input v-model="detail.uploadUrl"></el-input>
        </el-form-item>
        <el-form-item label="内容：" prop="content">
          <el-input type="textarea" v-model="detail.content"></el-input>
        </el-form-item>
        <el-form-item label="是否强制升级:" prop="isForce">
          <el-switch active-color="#13ce66" v-model="detail.isForce">
          </el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" @click="saveInfo()">保存</el-button>
      </span>
    </el-dialog> -->
    <el-dialog
      :visible="dialogVisible"
      title="修改"
      width="35%"
      @close="closeDialog"
    >
      <el-form :model="detail" ref="form" label-width="100px">
        <el-form-item label="平台：" prop="platform">
          <el-select v-model="detail.platform" placeholder="请选择" disabled>
            <el-option
              v-for="item in platformType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="商户：" prop="tenantId">
          <el-select v-model="detail.tenantId">
            <el-option
              v-for="item in tentIdlist"
              :key="item.id"
              :label="item.tenantName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="版本：" prop="version">
          <el-input v-model="detail.version"></el-input>
        </el-form-item>
        <el-form-item label="内容：" prop="content">
          <el-input
            v-model="detail.content"
            type="textarea"
            :rows="5"
          ></el-input>
        </el-form-item>
        <el-form-item label="下载地址：" prop="lineUrl">
          <el-input v-model="detail.lineUrl"></el-input>
        </el-form-item>

        <el-form-item label="uploadUrl：" prop="uploadUrl" v-if="detail.platform">
          <el-input v-model="detail.uploadUrl" disabled></el-input>
          <upload
            :platform="detail.platform"
            list-type="text"
            class="upload"
            :drag="false"
            :value="detail.uploadUrl"
            :data="{
              category: detail.platform,
              isKeepName: true,
              type: 1,
              tenantId: detail.tenantId,
            }"
            @uploaded="(url) => saveAppInfo(detail.platform, url)"
          >
            <a slot="content" class="edit-button">
              <i class="el-icon-edit"></i>
            </a>
          </upload>
        </el-form-item>

        <el-form-item label="状态:" prop="status">
          <el-switch
            active-color="#13ce66"
            :value="infoStatus(detail.status)"
            @change="changeInfoStatus(detail.status)"
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="是否强制升级:" prop="isForce">
          <el-switch active-color="#13ce66" v-model="detail.isForce">
          </el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handleSave('form')">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import Pagination from "components/pagination";
import Upload from "components/upload";
export default {
  name: "AppList",
  data() {
    return {
      dialogVisible: false,
      platformType: [
        {
          value: "android",
          label: "android",
        },
        {
          value: "ios_testflight",
          label: "ios_testflight",
        },
        {
          value: "ios_appstore",
          label: "ios_appstore",
        },
        {
          value: "google",
          label: "google",
        },
      ],
      params: {
        coinType: "",
        type: "",
        queryType: "0",
        queryValue: "",
        id: "",
        address: "",
      },
      detail: {},
      rules: {
        version: {
          required: true,
          message: "请填写",
        },
      },
      spanArr: [], // 需要合并的行数
      pos: 0, // 索引
    };
  },
  computed: {
    ...mapState("app", ["totalCount", "pagination", "tentIdlist"]),
    ...mapState("app", [
      "editingPlatform",
      "appList",
      "androidInfo",
      "iosInfo",
    ]),
    // ...mapGetters("app", ["appList"]),
  },
  components: {
    Pagination,
    Upload,
  },
  mounted() {
    // this.setEditingPlatform('apple');
    console.log("editingPlatform", this.editingPlatform);
    // this.getVersionAppInfo(this.editingPlatform).then(res => {
    //   this.detail = res.data;
    // });
  },
  methods: {
    ...mapActions("app", [
      "info",
      "saveVersionAppInfo",
      "getVersionAppInfo",
      "addApp",
      "saveInfo",
      "changeStatusApp",
      "handleSaveInfo",
    ]),
    ...mapMutations("app", ["setpage", "setPagination"]),
    ...mapMutations("app", ["setEditingPlatform"]),
    getSpanArr(data) {
      // 遍历数据
      for (let i = 0; i < data.length; i++) {
        // 如果是第一个数据，就将列表spanArr添加一个1，表示暂时只有一个名字相同的、且将索引pos赋值为0
        if (i === 0) {
          this.spanArr.push(1);
          this.pos = 0;
        } else {
          // 判断当前元素与上一个元素是否相同
          if (data[i].name === data[i - 1].name) {
            // 如果相同就将索引为 pos 的值加一
            this.spanArr[this.pos] += 1;
            // 且将数组添加 0
            this.spanArr.push(0);
          } else {
            // 如果元素不同了，就可以通过索引为 pos 的值知晓应该需要合并的行数
            // 同时，我们再次添加一个值1，表示重新开始判断重复姓名的次数
            this.spanArr.push(1);
            // 同时 索引加一
            this.pos = i;
          }
        }
      }
      console.log("索引数组：");
      console.log(this.spanArr);
    },
    updateOne(row) {
      this.$confirm("确认要修改吗？", "提示", { type: "warning" }).then(() => {
        this.addApp({ ...row }).then(() => {
          this.$message.success("确认成功！");
          this.$emit("refresh", this.pagination);
        });
      });
      // console.log("updateOne",row);
      // this.addApp({...row}).then(res=>{
      //   console.log("updateOne-adddddd",res);
      // })
    },
    handleCurrentChange(pagination) {
      this.setpage(pagination);
      this.$emit("refresh", pagination);
    },
    infoStatus(e) {
      return e == 1 ? true : false;
    },
    // closeDialog() {
    //   this.setEditingPlatform(null);
    // },
    changeInfoStatus(e) {
      console.log("eeeeee", e);
      this.detail.status = e == 1 ? false : true;
    },
    changeStatus(e) {
      const message = e ? "是否将状态设为关闭" : "是否将状态设为开启";
      this.$confirm(message, "提示", { type: "warning " }).then(() => {
        this.changeStatusApp({ id: e.id, status: e.status == 1 ? 0 : 1 }).then(
          (res) => {
            if (res.code == 0) {
              this.$message({
                message: "修改成功！",
                type: "success",
              });
              this.$emit("refresh", this.pagination);
            }
          }
        );
      });
    },
    saveAppInfo(platform, url) {
      console.log("url", url);
      this.$nextTick(() => {
        this.detail.uploadUrl = url;
      });
      // this.saveInfo({ platform, url }).then((res) => {
      //   this.$message({
      //     message: '上传成功！',
      //     type: 'success'
      //   });

      //   // this.info(this.detail.platform);
      //   // this.info('plist');
      // });
    },
    close() {
      this.dialogVisible = false;
      this.detail = {};
    },
    closeDialog() {
      this.dialogVisible = false;
      this.detail = {};
    },
    updateInfo(row) {
      this.dialogVisible = true;
      // this.editingUrl = row.appUrl;
      // this.editingPlatform = row.platform;
      // this.setEditingPlatform(row.platform);
      this.detail = JSON.parse(JSON.stringify(row));
    },
    handleSave() {
      this.handleSaveInfo({
        ...this.detail,
        status: this.detail.status == true ? 1 : 0,
      }).then((res) => {
        if (res.code == 0) {
          this.$message({
            message: "修改成功",
            type: "success",
          });
          this.$emit("refresh", this.pagination);
          this.dialogVisible = false;
        }
      });
    },
    // saveInfo() {
    //   this.saveVersionAppInfo({
    //     ...this.detail,
    //     platform: this.editingPlatform,
    //     url: this.editingUrl,
    //   }).then(() => {
    //     this.$message({
    //       message: "发布成功！",
    //       type: "success",
    //     });
    //     this.closeDialog();
    //   });
    // },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (rowIndex % 2 === 0) {
        if (columnIndex === 0) {
          return [1, 2];
        } else if (columnIndex === 1) {
          return [0, 0];
        }
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // console.log('rowIndex',rowIndex);
      // console.log('columnIndex',columnIndex);
      // console.log('column',column);
      console.log("row", row.platform);
      if (columnIndex === 0 || columnIndex === 3 || columnIndex === 2) {
        if (rowIndex % 2 === 0) {
          return {
            rowspan: 2,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
        // console.log(this.spanArr,'wwwwwwwwwwwwwwww');
        // const _row = this.spanArr[rowIndex];
        // const _col = _row > 0 ? 1 : 0;
        // return {
        //     rowspan: _row,
        //     colspan: _col
        // }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 120px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
.url-con {
  display: flex;
  margin-bottom: 4px;
  .url-name {
    min-width: 40px;
    display: flex;
    align-items: center;
  }
}
</style>
